<template>
  <div>
    <base-card :loading="loading" class="rounded-lg pb-2">
      <v-tabs v-model="tab" show-arrows class="rounded-lg" height="36px">
        <v-tab
          v-for="item in tabs"
          class="rounded-lg"
          :key="item.id"
        >
          <v-icon left small>{{ item.icon }}</v-icon>
          {{ item.name }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" :touchless="tabs[tab]?.touchless">
        <v-tab-item
          v-for="item in tabs"
          :key="item.id"
          class="pa-4"
        >
          <component :is="item.component" />
        </v-tab-item>
      </v-tabs-items>
    </base-card>

    <v-bottom-sheet
      v-model="navigationSheet"
      inset
      max-width="550px"
      :overlay-opacity="0.8"
      content-class="elevation-0"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          dark
          style="position: fixed; bottom: 76px; right: 16px; z-index: 5"
          float
          v-bind="attrs"
          v-on="on"
          color="primary"
        >
          <v-icon>mdi-dots-grid</v-icon>
        </v-btn>
      </template>
      <div class="mb-4 px-4 d-flex w-full">
        <v-card class="pa-3 pb-1 rounded-lg w-full">
          <v-row dense class="mx-0">
            <v-col
              v-for="item in tabs"
              :key="item.id"
              cols="4"
              sm="4"
              md="3"
            >
              <v-card
                @click="selectTab(item.id)"
                outlined
                height="90px"
                elevation="0"
                class="pa-2"
              >
                <div
                  class="d-flex align-center justify-center flex-column h-full text-center lh-1 gap-2"
                >
                  <v-icon>{{ item.icon }}</v-icon>
                  {{ item.name }}
                </div>
              </v-card>
            </v-col>
          </v-row>
          <div class="d-flex justify-center">
            <v-btn @click="navigationSheet = false" text small>Fechar</v-btn>
          </div>
        </v-card>
      </div>
    </v-bottom-sheet>
  </div>
</template>

<script>
import AccountsList from "@/components/admin/messager/AccountsList.vue";
import MessageLogsList from "@/components/admin/messager/MessageLogsList.vue";

export default {
  metaInfo() {
    return { title: "Mensageria" };
  },
  data: () => ({
    loading: false,
    tab: null,
    navigationSheet: false,
    tabs: [
      {
        id: "contas",
        name: "Contas",
        component: "AccountsList",
        icon: "mdi-account-multiple",
      },
      {
        id: "logs",
        name: "Logs",
        component: "MessageLogsList",
        icon: "mdi-message-text-clock-outline",
      },
    ],
  }),
  methods: {
    selectTab(tabId) {
      if (tabId) window.location.replace("#" + tabId);
      const hash = tabId || this.$route.hash.replace("#", "") || "contas";
      const index = this.tabs.findIndex((t) => t.id === hash);
      if (index >= 0) this.tab = index;
      this.navigationSheet = false;
    },
    vibrate() {
      if (navigator.vibrate) navigator.vibrate(50);
    },
  },
  watch: {
    tab: {
      handler(val, oldVal) {
        if (val !== null && oldVal !== null) this.vibrate();
        const item = this.tabs[val];
        if (item) window.location.replace("#" + item.id);
      },
      immediate: true,
    },
    "$route.hash"() {
      this.selectTab();
    },
  },
  components: {
    AccountsList,
    MessageLogsList,
  },
  mounted() {
    this.tab = 0;
    this.selectTab();
  },
};
</script>

<style scoped>
.gap-2 {
  gap: 8px;
}
</style>
